module.exports = __webpack_public_path__ + "static/media/pandemic.f6760075.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereby/pandemic.png
// module id = 331
// module chunks = 0